import axios from "axios";
import { json } from "stream/consumers";
import { ProductI, ProductRI, SpecialOfferI } from "types/ProductI";
import { ResponseError } from "types/responses/ResponseError";
import { getHeaders } from "./AuthHeader";

const API_URL = process.env.REACT_APP_API_URL;
// const product_ids = [
//     // 201, 209, 202, 203, 204, 4, 205, 206
//     201, 202, 203, 204, 4, 205, 206
// ]

export async function GetEshopProductsService() {    
    const products_settings: any[] = await (await fetch(process.env.PUBLIC_URL + '/data/products.json')).json()

    // console.log(products_settings);

    try {

        let product_ids = products_settings.map(item => {
            return item.id
        })
        // console.log("product ids".toUpperCase(), product_ids);
        
        const response_products = await axios.get(
            API_URL + '/eshop/products',
            {
                params: {
                    product_ids: product_ids
                },
                headers: getHeaders()
            }
        )


        if (!('products' in response_products.data)) {
            return "no_products_error"
        }
        // console.log(response.data.products);
        

        const json_products = JSON.parse(response_products.data.products)
        // console.log(json_products);
        // console.log("Get Eshop Products Service".toUpperCase(), json_products);

        // products_settings
        // json_products

        let products: ProductI[] = []
        json_products.forEach((value: ProductRI, index) => {
                        
            let settings = products_settings.find((i) => i.id == value.ID_TYP_CLENSTVI)
            
            // console.log(value.ID_TYP_CLENSTVI);
            // console.log(settings);

            let p:ProductI = {
                product_id: value.ID_TYP_CLENSTVI,
                name: settings?.name || value.POPIS,
                description: settings?.descritpion || value.POPIS, 
                price_registration: value.ZAPISNE,
                length: value.DELKA, 
                order: settings?.order || index
            }
            products.push(p)
        })

        return products.sort((p,q) =>  {
            // console.log(p.order);
            // console.log(q.order);
            
            return (p.order - q.order)
        })
    } catch(error) {
        // console.log(error);
        return ResponseError.general_error
        
    }
}

export async function GetSpecialOfferProductsServece() {
    try {
        const special_offer_settings: any[] = await(
            await( fetch(process.env.PUBLIC_URL + '/data/special_offer.json'))
        ).json()

        if (special_offer_settings.length == 0) {
            return []
        }

        let product_ids = special_offer_settings.map(item => {
            return item.id
        })

        const response_special_offer = await axios.get(
            API_URL + '/eshop/products',
            {
                params: {
                    product_ids: product_ids,
                    
                },
                headers: getHeaders()
            }
        )
        if (!('products' in response_special_offer.data)) {
            return "no_special_offer_products_error"
        }
        const json_products = JSON.parse(response_special_offer.data.products)
        let products: SpecialOfferI[] = []
        json_products.forEach((value: ProductRI, index) => {
            let settings = special_offer_settings.find((i) => i.id == value.ID_TYP_CLENSTVI)
            let p:SpecialOfferI = {
                product_id: value.ID_TYP_CLENSTVI,
                name: settings?.name || value.POPIS,
                description: settings?.descritpion || value.POPIS, 
                price_registration: value.ZAPISNE,
                length: value.DELKA, 
                order: settings?.order || index,
                display_from: new Date(settings.display_from),
                display_to: new Date(settings.display_to)
            }
            products.push(p)
        })

        return products

    } catch(error) {
        return "Get_Special_Offer_Products_Servece_error".toLowerCase()
    }
}